import { render, staticRenderFns } from "./profileEleve.vue?vue&type=template&id=63200f9a&scoped=true&"
import script from "./profileEleve.vue?vue&type=script&lang=js&"
export * from "./profileEleve.vue?vue&type=script&lang=js&"
import style0 from "./profileEleve.vue?vue&type=style&index=0&id=63200f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63200f9a",
  null
  
)

export default component.exports